// extracted by mini-css-extract-plugin
export default {"no-result-root":"NoSAMResultFound_no-result-root__iufxr","blob":"NoSAMResultFound_blob__L1PWB","group":"NoSAMResultFound_group__OBOxy","desc":"NoSAMResultFound_desc__EPgwj"};